import reducers from './reducers';

const orgsReducers = {
  allOrganizations: reducers.allOrgsReducer,
};

export { orgsReducers };
